import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PatientChartStatusEnum {
    active = 1,
    discharged = 2,
    pending = 3,
    nonadmitted = 4
}

export class PatientChartStatusEnumClass extends EnumWithDescription<PatientChartStatusEnum> {
    public readonly enum = PatientChartStatusEnum;
    public readonly enumName: string = "PatientChartStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PatientChartStatusEnum>> = new Map([
        [
            "Active",
            {
                value: PatientChartStatusEnum.active,
                name: "Active"
            }
        ],
        [
            "Discharged",
            {
                value: PatientChartStatusEnum.discharged,
                name: "Discharged"
            }
        ],
        [
            "Pending",
            {
                value: PatientChartStatusEnum.pending,
                name: "Pending"
            }
        ],
        [
            "Non-Admitted",
            {
                value: PatientChartStatusEnum.nonadmitted,
                name: "Non-Admitted"
            }
        ]
    ]);
}

export const PatientChartStatus = new PatientChartStatusEnumClass();
